import { Components, Theme } from "@mui/material/styles";

export const MuiTableRow = (theme: Theme) =>
  ({
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&:hover": {
            background: theme.palette.background.light,
          },
        },
      },
    },
  }) satisfies Components<Theme>;
